export enum SuccessStrings {
  // Page Messages
  FinalizedSuccessfully = 'SV3L',
  ClickXToClose = 'xvd+',
}
